import React, { Component } from "react";
import deletee from "../assets/delete.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default class BluckCellButton extends Component {
  render() {
    return (
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 200, hide: 200 }}
          overlay={
            <Tooltip style={{ fontFamily: "SFUIDisplay", fontSize: "12px" }}>
              حذف
            </Tooltip>
          }
        >
          <div
            style={{ cursor: "pointer", userSelect: "none" }}
            onClick={() => this.props.deleteItem(this.props.value)}
          >
            <img
              src={deletee}
              alt=""
              style={{ objectFit: "contain", height: "20px" }}
            />
          </div>
        </OverlayTrigger>
      </div>
    );
  }
}
